module.exports = __webpack_public_path__ + "static/media/gb-nir.bca162fd.svg";